import React from 'react';
import { Switch, Route} from 'react-router-dom';
import Home from './pages/home';
import Empresa from './pages/empresa';
import Servicos from './pages/servicos';
import Indices from './pages/indices';
import Links from './pages/links';
import Simples from './pages/subpages/simples';
import Federal from './pages/subpages/federal';
import Vencimentos from './pages/subpages/vencimentos';
import Contribuicoes from './pages/subpages/contribuicoes';
import Salarios from './pages/subpages/salario';
import Irenda from './pages/subpages/impostoderenda';
import Contato from './pages/contato';
function Routes(){
    
    return(
        <Switch>
            <Route path="/futuro/" exact component={Home} />
            <Route path="/futuro/empresa/" component={Empresa} />
            <Route path="/futuro/servicos" component={Servicos} />
            <Route path="/futuro/indices" component={Indices} />
            <Route path="/futuro/links" component={Links} />
            <Route path="/futuro/simples" component={Simples} />
            <Route path="/futuro/federal" component={Federal} />
            <Route path="/futuro/vencimentos" component={Vencimentos} />
            <Route path="/futuro/contribuicoes" component={Contribuicoes} />
            <Route path="/futuro/salarios" component={Salarios} />
            <Route path="/futuro/impostoderenda" component={Irenda} />
            <Route path="/futuro/contato" component={Contato} />
        </Switch>
    )
}
export default Routes;